<template>
  <div class="feature">
	<div class="featureImg" :src="feature.caseImg" :style="{'background-image': 'url(' + require('../assets/'+feature.img) + ')'}"></div>
	<h4 class="title"><p>{{feature.title}}</p></h4>
	<!-- <hr align="left"> -->
	<div class="blurbText">{{feature.blurb}}</div>
  </div>
</template>


<script>
export default {
  name: 'FeatureItem',
  props: ['feature']
}
</script>
<style lang="scss" scoped>
.feature {
	border: 1px solid $darkblue;
	margin: 1%;
	padding-bottom: 1%;
}
.featureImg {
	width: 100%;
	height: 260px;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	position: relative;
}
.title {
	//background-color: $darkblue;
	color: white;
	color: black;
	display: flex;
	justify-content: center;

	p {
		margin: 0;
		padding-bottom: 0.8rem;
		border-bottom: $blue 2px solid;
	}
}
.blurbText {
	padding-bottom: 1rem;
	padding-right: 1rem;
	padding-left: 1rem;
}
hr {
	margin: 0 auto;
    height: 0;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
}
hr {
    margin-top: 20px;
    margin-bottom: 20px;
    border: 0;
    border-top: 1px solid #eee;
}
hr {
    width: 40px;
    height: 2px;
    margin-top: 20px;
    background-color: $blue;
}
</style>
